import { Component, OnInit } from '@angular/core';
import { IxellAPIService, IRentingLight, BankName, OrderLight, ICtcV1, IRentingInfo, IRentingPatch } from 'src/app/tools/api.service';
import { ErrorService } from 'src/app/tools/error.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { HeaderService } from 'src/app/tools/header.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RentingLight } from '../../models/rentinglight';
import { RentingInfo } from '../../models/rentinginfo';
import { Constants, Country } from 'src/app/entities/Constants';
import { Utils } from 'src/app/tools/utils';

@Component({
    selector: 'app-adminlacourRenting',
    templateUrl: './adminlacourRenting.component.html',
    styleUrls: ['./adminlacourRenting.component.scss']
})

export class AdminlacourRentingComponent implements OnInit {
    displayedColumnsS0: string[] = ['rentingId', 'rentingDate', 'companyUnisiteCode', 'companySocialReason', 'country', 'ctc', 'ctcPhone', 'rentingDuration', 'sageCode', 'bank', 'invoiceCode1', 'finalEdit', 'excel'];
    displayedColumnsS1: string[] = ['status', 'rentingId', 'treatmentDate', 'companyUnisiteCode', 'companySocialReason', 'country', 'ctc', 'ctcPhone', 'rentingDuration', 'sageCode', 'bank', 'invoiceCode1', 'show', 'excel'];
    displayedColumnsS2: string[] = ['status', 'rentingId', 'treatmentDate', 'companyUnisiteCode', 'companySocialReason', 'country', 'ctc', 'ctcPhone', 'rentingDuration', 'sageCode', 'bank', 'invoiceCode1', 'show'];
    displayedColumnsS4: string[] = ['rentingId', 'rentingDate', 'companyUnisiteCode', 'companySocialReason', 'country', 'ctc', 'ctcPhone', 'rentingDuration', 'sageCode', 'bank', 'invoiceCode1', 'finalEdit', 'excel'];

    displayedColumns: string[];

    // Sub
    rentingSub: any;
    rentingInfoSub: any;
    rentingAddInfoSub: any;
    checkedRentingSub: any;
    orderLightSub: any;
    statusRentingSub: any;
    selectCTForRentingSub: any;
    updateRentingInfoSub: any;
    selectRentableProductsLightSub: any;

    // Objets et tableaux
    rentingLight: RentingLight;
    allRenting: RentingLight[] = [];
    rentingStatus0: RentingLight[] = [];
    rentingStatus1: RentingLight[] = [];
    rentingStatus2: RentingLight[] = [];
    rentingStatus4: RentingLight[] = [];
    rentingLst: RentingLight[] = [];
    rentingSource: any;
    dataInfo: any[] = [];
    mailInfo: any[] = [];

    rentingInfo: RentingInfo;
    allRentingInfo: RentingInfo[] = [];

    // js pour les tab
    actualtab = '';
    actualpane = '';

    confirmationStatus: string = '';
    confirmationCb: any = null;
    additionalConfirmText: string = '';
    actualStatus: number = 0;
    //actualTabStatus:number = 0;
    actualRentingID: number;
    actualCompanyID: number;

    isEditable: boolean = false;
    isPending: boolean = false;

    public noWhitespaceValidator(control: UntypedFormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }

    // Formulaire
    rentingAddInfosForm = new UntypedFormGroup({
        companyUnisiteCode: new UntypedFormControl('', [this.noWhitespaceValidator]),
        sageCode: new UntypedFormControl('', [this.noWhitespaceValidator]),
        bank: new UntypedFormControl('', [Validators.min(1)]),
        invoiceCode: new UntypedFormControl('', [this.noWhitespaceValidator])
    });

    errorForm: boolean = false;

    listOfBanks = {
        "list": [
            { "value": "1", "name": "BNP" },
            { "value": "2", "name": "CMCIC" }
        ]
    };

    orderLight: OrderLight[];
    totalAmountOrder: number;

    // Edit
    originalEdit?: IRentingInfo = undefined;
    originalOrder?: OrderLight[] = undefined;
    editStatus: number = 0;
    availableCTs: ICtcV1[];
    availableCountries: Country[] = Utils.countries();
    availableProducts: OrderLight[] = [];
    currCtcId: number = -1;
    currIxellAccount: string = '';
    currTarif: string = '';
    currTech: string = '';
    currCpnyType: string = '';
    currCpnyTypeName: string = '';
    currLeader: string = '';
    currBodyshopInter: string = '';
    currCpnyPhone: string = '';
    currCpnyEMail: string = '';
    currCpnyDirect: string = '';
    currSocialReason: string = '';
    currCpnyAddr: string = '';
    currCpnyPostalCode: string = '';
    currCpnyCity: string = '';
    currCpnyCountry: string = '';
    currCpnySiren: string = '';
    currCpnyTva: string = '';

    constructor(private api: IxellAPIService, private errorService: ErrorService, private formBuilder: UntypedFormBuilder, private headerService: HeaderService, private snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        Utils.deleteStorageData();
        this.getData("0");
        this.actualtab = "nav-stat0-tab";
        this.actualpane = "nav-stat0";
        this.isPending = true; // affichage des boutons Accepter/Refuser/Abandon seulement pour les formulaires en attente
        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeLogo(null);
    }

    getData(status: string) {
        this.rentingStatus0 = [];
        this.rentingStatus1 = [];
        this.rentingStatus2 = [];
        this.rentingStatus4 = [];
        this.rentingLst = [];
        this.rentingSource = null;
        this.allRenting = [];
        this.rentingSub = this.api.selectAllRenting().subscribe(data => {
            if (data != null) {
                data.forEach(item => {
                    this.allRenting.push(RentingLight.parseToRentingLight(item));
                    if (item.status == 0)
                        this.rentingStatus0.push(RentingLight.parseToRentingLight(item));
                    if (item.status == 1)
                        this.rentingStatus1.push(RentingLight.parseToRentingLight(item));
                    if (item.status == 2 || item.status == 3)
                        this.rentingStatus2.push(RentingLight.parseToRentingLight(item));
                    if (item.status == 4)
                        this.rentingStatus4.push(RentingLight.parseToRentingLight(item));
                });
                switch (status) {
                    case "0":
                        this.rentingStatus0.sort((a, b) => { return Constants.compareDate(a.rentingDate, b.rentingDate, false); })
                        this.rentingLst = this.rentingStatus0;
                        this.rentingSource = new MatTableDataSource(this.rentingStatus0);
                        this.displayedColumns = this.displayedColumnsS0;
                        break;
                    case "1":
                        this.rentingStatus1.sort((a, b) => { return Constants.compareDate(a.rentingDate, b.rentingDate, false); })
                        this.rentingLst = this.rentingStatus1;
                        this.rentingSource = new MatTableDataSource(this.rentingStatus1);
                        this.displayedColumns = this.displayedColumnsS1;
                        break;
                    case "2":
                        this.rentingStatus2.sort((a, b) => { return Constants.compareDate(a.rentingDate, b.rentingDate, false); })
                        this.rentingLst = this.rentingStatus2;
                        this.rentingSource = new MatTableDataSource(this.rentingStatus2);
                        this.displayedColumns = this.displayedColumnsS2;
                        break;
                    case "4":
                        this.rentingStatus4.sort((a, b) => { return Constants.compareDate(a.rentingDate, b.rentingDate, false); })
                        this.rentingLst = this.rentingStatus4;
                        this.rentingSource = new MatTableDataSource(this.rentingStatus4);
                        this.displayedColumns = this.displayedColumnsS4;
                        break;
                }
            }
            if (this.rentingSub != null) this.rentingSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "allRenting", new Date().toString());
            if (this.rentingSub != null) this.rentingSub.unsubscribe();
        });

        this.selectRentableProductsLightSub = this.api.selectRentableProductsLight('fr').subscribe(data => {
            this.availableProducts = data;
            if (this.selectRentableProductsLightSub != null) this.selectRentableProductsLightSub.unsubscribe();
        }, error => {
            if (this.selectRentableProductsLightSub != null) this.selectRentableProductsLightSub.unsubscribe();
        });
    }

    // Changement d'onglet
    toggleTab(status: string, pane: string, tab: string) {
        switch (status) {
            case "0":
                this.getData("0");
                this.isPending = true;
                break;
            case "1":
                this.getData("1");
                this.isPending = false;
                break;
            case "2":
                this.getData("2");
                this.isPending = false;
                break;
            case "4":
                this.getData("4");
                this.isPending = false;
                break;
        }
        document.getElementById(this.actualtab).classList.remove("active");
        document.getElementById(tab).classList.add("active");
        this.actualpane = pane;
        this.actualtab = tab;
    }

    // Rechercher
    applyFilter(filterValue: string) {
        this.rentingSource.filter = filterValue.trim().toLowerCase();
    }

    // Refresh la liste sans récupérer les données en base
    refreshRentingList(status: number) {
        this.rentingStatus0 = [];
        this.rentingStatus1 = [];
        this.rentingStatus2 = [];
        this.rentingStatus4 = [];
        this.allRenting.forEach(element => {
            if (element.status == 0 || element.status == 1 && status == 2)
                this.toggleTab('1', 'nav-stat1', 'nav-stat1-tab');
            this.rentingStatus1.push(element);
            if (element.status == 2 || element.status == 3 && status == 3)
                this.toggleTab('2', 'nav-stat2', 'nav-stat2-tab');
            this.rentingStatus2.push(element);
            if (element.status == 4)
                this.rentingStatus4.push(element);
        });
        switch (status) {
            case 0:
                this.rentingSource = new MatTableDataSource(this.rentingStatus0.slice());
                this.rentingLst = this.rentingStatus0.slice();
                this.displayedColumns = this.displayedColumnsS0;
                break;
            case 1:
                this.rentingSource = new MatTableDataSource(this.rentingStatus1.slice());
                this.rentingLst = this.rentingStatus1.slice();
                this.displayedColumns = this.displayedColumnsS1;
                break;
            case 2:
                this.rentingSource = new MatTableDataSource(this.rentingStatus2.slice());
                this.rentingLst = this.rentingStatus2.slice();
                this.displayedColumns = this.displayedColumnsS2;
                break;
            case 4:
                this.rentingSource = new MatTableDataSource(this.rentingStatus4.slice());
                this.rentingLst = this.rentingStatus4.slice();
                this.displayedColumns = this.displayedColumnsS4;
                break;
        }
    }

    // Refresh les données en récupérant les données en base
    refreshTab() {
        let tab = this.actualtab;
        switch (tab) {
            case "nav-stat0-tab":
                this.getData("0");
                break;
            case "nav-stat1-tab":
                this.getData("1");
                break;
            case "nav-stat2-tab":
                this.getData("2");
                break;
            case "nav-stat4-tab":
                this.getData("4");
                break;
        }
    }

    // Case à cocher Mouvement
    onIsCheckedChange(id: number) {
        this.checkedRentingSub = this.api.isCheckedRenting(id).subscribe(data => {
            if (this.checkedRentingSub != null) this.checkedRentingSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.checkedRentingSub != null) this.checkedRentingSub.unsubscribe();
        })
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['blue-snackbar']
        });
    }

    // Affichage des infos dans la modale Editer
    displayInfoRenting(rentingID: number, isEditable: number) {
        if (isEditable == 0) {
            this.isEditable = true;
        } else {
            this.isEditable = false;
        }
        this.editStatus = 0;
        this.rentingInfoSub = this.api.selectRentingInfo(rentingID).subscribe(data => {
            if (data) {
                this.dataInfo = [];
                this.dataInfo = data;
                this.originalEdit = { ...data[0] } as IRentingInfo;
                this.actualRentingID = rentingID;
                let modal = document.getElementById('editRentingModal');
                modal.style.display = 'block';
                let index = this.allRenting.findIndex(i => i.rentingID == rentingID);
                this.rentingAddInfosForm.setValue({
                    companyUnisiteCode: this.allRenting[index].companyUnisiteCode,
                    sageCode: this.allRenting[index].sageCode,
                    bank: this.allRenting[index].bank.toString(),
                    invoiceCode: this.allRenting[index].invoiceCode,
                })
                this.errorForm = false;
                this.rentingAddInfosForm.markAsUntouched();
            }
            this.orderLight = [];
            this.totalAmountOrder = 0;
            this.orderLightSub = this.api.selectOrderLightById(rentingID, 'fr').subscribe(data => {
                this.orderLight = data;
                this.originalOrder = data.map(order => ({ ...order })) as OrderLight[];
                this.orderLight.forEach(el => this.totalAmountOrder += (el.amountP * el.qty))
                if (this.orderLightSub != null) this.orderLightSub.unsubscribe();
            }, error => {
                console.log(error);
                if (this.orderLightSub != null) this.orderLightSub.unsubscribe();
            });
            if (this.rentingInfoSub != null) this.rentingInfoSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "infoRenting, rentingID = " + rentingID, new Date().toString());
            console.log(error);
            this.errorForm = true;
            if (this.rentingInfoSub != null) this.rentingInfoSub.unsubscribe();
        });
    }

    // Affichage de la modale Mail
    displayMailRenting(id: number, mail: string, language: string) {
        let modal = document.getElementById('mailModal');
        modal.style.display = 'block';
        this.mailInfo = [];
        this.mailInfo.push({ rentingID: id, ctcMail: mail, ctcLanguage: language });
    }

    closeModal(name: string) {
        let modal = document.getElementById(name);
        modal.style.display = "none";
    }

    confirmationModal(status: number, cb: any = null) {
        this.confirmationStatus = '';
        this.confirmationCb = cb;
        this.actualStatus = status;
        let modal = document.getElementById('confirmationModal');
        modal.style.display = 'block';
        //this.actualTabStatus = tabstatus;
        switch (status) {
            case 0:
                this.confirmationStatus = "Enregistrer";
                break;
            case 1:
                this.confirmationStatus = "Accepter";
                break;
            case 2:
                this.confirmationStatus = "Refuser";
                break;
            case 3:
                this.confirmationStatus = "Abandonner";
                break;
        }
    }

    // Check edit status
    isEditing(flag: number): boolean {
        return (this.editStatus & flag) > 0;
    }

    // Modification du CT depuis le modal Editer
    editCT() {
        this.selectCTForRentingSub = this.api.selectCTForRenting(this.dataInfo[0].rentingID).subscribe(data => {
            this.availableCTs = data;

            this.currCtcId = this.dataInfo[0].ctcID;
            this.editStatus |= 1;

            if (this.selectCTForRentingSub != null) this.selectCTForRentingSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "editCT, rentingID = " + this.dataInfo[0].rentingID, new Date().toString());
            console.log(error);
            this.errorForm = true;
            if (this.selectCTForRentingSub != null) this.selectCTForRentingSub.unsubscribe();
        });

    }

    // Valider modifs du CT depuis le modal Editer
    validateCT() {
        let chosenCT = this.availableCTs.find(ct => ct.idCtc == this.currCtcId);

        this.dataInfo[0].ctcID = chosenCT.idCtc;
        this.dataInfo[0].ctcFirstname = chosenCT.firstname;
        this.dataInfo[0].ctcName = chosenCT.name;
        this.dataInfo[0].ctcPhone = chosenCT.phone;
        this.dataInfo[0].ctcMail = chosenCT.mail;
        this.dataInfo[0].ctcLanguage = chosenCT.language;
        this.editStatus &= ~1;
    }

    // Annuler modifs du CT depuis le modal Editer
    cancelCT() {
        this.editStatus &= ~1;
    }

    // Défaire modifs du CT depuis le modal Editer
    rewindCT() {
        this.dataInfo[0].ctcID = this.originalEdit.ctcID;
        this.dataInfo[0].ctcFirstname = this.originalEdit.ctcFirstname;
        this.dataInfo[0].ctcName = this.originalEdit.ctcName;
        this.dataInfo[0].ctcPhone = this.originalEdit.ctcPhone;
        this.dataInfo[0].ctcMail = this.originalEdit.ctcMail;
        this.dataInfo[0].ctcLanguage = this.originalEdit.ctcLanguage;
    }

    // Modification du N° de compte Ixell depuis le modal Editer
    editIxAcc() {
        this.currIxellAccount = this.dataInfo[0].ixellAccount;
        this.editStatus |= 2;
    }

    // Valider modifs du N° de compte Ixell depuis le modal Editer
    validateIxAcc() {
        this.dataInfo[0].ixellAccount = this.currIxellAccount;
        this.editStatus &= ~2;
    }

    // Annuler modifs du N° de compte Ixell depuis le modal Editer
    cancelIxAcc() {
        this.editStatus &= ~2;
    }

    // Défaire modifs du N° de compte Ixell depuis le modal Editer
    rewindIxAcc() {
        this.dataInfo[0].ixellAccount = this.originalEdit.ixellAccount;
    }

    // Modification du Tarif depuis le modal Editer
    editTarif() {
        this.currTarif = this.dataInfo[0].customerStatus;
        this.editStatus |= 4;
    }

    // Valider modifs du Tarif depuis le modal Editer
    validateTarif() {
        this.dataInfo[0].customerStatus = this.currTarif;
        this.editStatus &= ~4;
    }

    // Annuler modifs du Tarif depuis le modal Editer
    cancelTarif() {
        this.editStatus &= ~4;
    }

    // Défaire modifs du Tarif depuis le modal Editer
    rewindTarif() {
        this.dataInfo[0].customerStatus = this.originalEdit.customerStatus;
    }

    // Modification de la Technologie depuis le modal Editer
    editTech() {
        this.currTech = this.dataInfo[0].technology;
        this.editStatus |= 8;
    }

    // Valider modifs de la Technologie depuis le modal Editer
    validateTech() {
        this.dataInfo[0].technology = this.currTech;
        this.editStatus &= ~8;
    }

    // Annuler modifs de la Technologie depuis le modal Editer
    cancelTech() {
        this.editStatus &= ~8;
    }

    // Défaire modifs de la Technologie depuis le modal Editer
    rewindTech() {
        this.dataInfo[0].technology = this.originalEdit.technology;
    }

    // Modification de la Compagnie depuis le modal Editer
    editCpnyType() {
        this.currCpnyType = this.dataInfo[0].companyType;
        this.editStatus |= 16;
    }

    // Valider modifs de la Compagnie depuis le modal Editer
    validateCpnyType() {
        this.dataInfo[0].companyType = this.currCpnyType;
        this.editStatus &= ~16;
    }

    // Annuler modifs de la Compagnie depuis le modal Editer
    cancelCpnyType() {
        this.editStatus &= ~16;
    }

    // Défaire modifs de la Compagnie depuis le modal Editer
    rewindCpnyType() {
        this.dataInfo[0].companyType = this.originalEdit.companyType;
    }

    // Modification du nom de la Compagnie depuis le modal Editer
    editCpnyTypeName() {
        this.currCpnyTypeName = this.dataInfo[0].companyTypeName;
        this.editStatus |= 32;
    }

    // Valider modifs du nom de la Compagnie depuis le modal Editer
    validateCpnyTypeName() {
        this.dataInfo[0].companyTypeName = this.currCpnyTypeName;
        this.editStatus &= ~32;
    }

    // Annuler modifs du nom de la Compagnie depuis le modal Editer
    cancelCpnyTypeName() {
        this.editStatus &= ~32;
    }

    // Défaire modifs du nom de la Compagnie depuis le modal Editer
    rewindCpnyTypeName() {
        this.dataInfo[0].companyTypeName = this.originalEdit.companyTypeName;
    }

    // Modification du Dirigeant depuis le modal Editer
    editLeader() {
        this.currLeader = this.dataInfo[0].leader;
        this.editStatus |= 64;
    }

    // Valider modifs du Dirigeant depuis le modal Editer
    validateLeader() {
        this.dataInfo[0].leader = this.currLeader;
        this.editStatus &= ~64;
    }

    // Annuler modifs du Dirigeant depuis le modal Editer
    cancelLeader() {
        this.editStatus &= ~64;
    }

    // Défaire modifs du Dirigeant depuis le modal Editer
    rewindLeader() {
        this.dataInfo[0].leader = this.originalEdit.leader;
    }

    // Modification de l'Interlocuteur depuis le modal Editer
    editBodyshopInter() {
        this.currBodyshopInter = this.dataInfo[0].bodyshopInterlocutor;
        this.editStatus |= 128;
    }

    // Valider modifs de l'Interlocuteur depuis le modal Editer
    validateBodyshopInter() {
        this.dataInfo[0].bodyshopInterlocutor = this.currBodyshopInter;
        this.editStatus &= ~128;
    }

    // Annuler modifs de l'Interlocuteur depuis le modal Editer
    cancelBodyshopInter() {
        this.editStatus &= ~128;
    }

    // Défaire modifs de l'Interlocuteur depuis le modal Editer
    rewindBodyshopInter() {
        this.dataInfo[0].bodyshopInterlocutor = this.originalEdit.bodyshopInterlocutor;
    }

    // Modification du Téléphone depuis le modal Editer
    editCpnyPhone() {
        this.currCpnyPhone = this.dataInfo[0].companyPhone;
        this.editStatus |= 256;
    }

    // Valider modifs du Téléphone depuis le modal Editer
    validateCpnyPhone() {
        this.dataInfo[0].companyPhone = this.currCpnyPhone;
        this.editStatus &= ~256;
    }

    // Annuler modifs du Téléphone depuis le modal Editer
    cancelCpnyPhone() {
        this.editStatus &= ~256;
    }

    // Défaire modifs du Téléphone depuis le modal Editer
    rewindCpnyPhone() {
        this.dataInfo[0].companyPhone = this.originalEdit.companyPhone;
    }

    // Modification de l'E-Mail depuis le modal Editer
    editCpnyEMail() {
        this.currCpnyEMail = this.dataInfo[0].companyMail;
        this.editStatus |= 512;
    }

    // Valider modifs de l'E-Mail depuis le modal Editer
    validateCpnyEMail() {
        this.dataInfo[0].companyMail = this.currCpnyEMail;
        this.editStatus &= ~512;
    }

    // Annuler modifs de l'E-Mail depuis le modal Editer
    cancelCpnyEMail() {
        this.editStatus &= ~512;
    }

    // Défaire modifs de l'E-Mail depuis le modal Editer
    rewindCpnyEMail() {
        this.dataInfo[0].companyMail = this.originalEdit.companyMail;
    }

    // Modification de la Ligne Directe depuis le modal Editer
    editCpnyDirect() {
        this.currCpnyDirect = this.dataInfo[0].companyDirectLign;
        this.editStatus |= 1024;
    }

    // Valider modifs de la Ligne Directe depuis le modal Editer
    validateCpnyDirect() {
        this.dataInfo[0].companyDirectLign = this.currCpnyDirect;
        this.editStatus &= ~1024;
    }

    // Annuler modifs de la Ligne Directe depuis le modal Editer
    cancelCpnyDirect() {
        this.editStatus &= ~1024;
    }

    // Défaire modifs de la Ligne Directe depuis le modal Editer
    rewindCpnyDirect() {
        this.dataInfo[0].companyDirectLign = this.originalEdit.companyDirectLign;
    }

    // Modification de la Raison sociale depuis le modal Editer
    editSocialReason() {
        this.currSocialReason = this.dataInfo[0].companySocialReason;
        this.editStatus |= 2048;
    }

    // Valider modifs de la Raison sociale depuis le modal Editer
    validateSocialReason() {
        this.dataInfo[0].companySocialReason = this.currSocialReason;
        this.editStatus &= ~2048;
    }

    // Annuler modifs de la Raison sociale depuis le modal Editer
    cancelSocialReason() {
        this.editStatus &= ~2048;
    }

    // Défaire modifs de la Raison sociale depuis le modal Editer
    rewindSocialReason() {
        this.dataInfo[0].companySocialReason = this.originalEdit.companySocialReason;
    }

    // Modification l'Adresse depuis le modal Editer
    editCpnyAddr() {
        this.currCpnyAddr = this.dataInfo[0].companyAddress;
        this.editStatus |= 4096;
    }

    // Valider modifs l'Adresse depuis le modal Editer
    validateCpnyAddr() {
        this.dataInfo[0].companyAddress = this.currCpnyAddr;
        this.editStatus &= ~4096;
    }

    // Annuler modifs l'Adresse depuis le modal Editer
    cancelCpnyAddr() {
        this.editStatus &= ~4096;
    }

    // Défaire modifs l'Adresse depuis le modal Editer
    rewindCpnyAddr() {
        this.dataInfo[0].companyAddress = this.originalEdit.companyAddress;
    }

    // Modification du Code postal depuis le modal Editer
    editCpnyPostalCode() {
        this.currCpnyPostalCode = this.dataInfo[0].companyPostalCode;
        this.editStatus |= 8192;
    }

    // Valider modifs du Code postal depuis le modal Editer
    validateCpnyPostalCode() {
        this.dataInfo[0].companyPostalCode = this.currCpnyPostalCode;
        this.editStatus &= ~8192;
    }

    // Annuler modifs du Code postal depuis le modal Editer
    cancelCpnyPostalCode() {
        this.editStatus &= ~8192;
    }

    // Défaire modifs du Code postal depuis le modal Editer
    rewindCpnyPostalCode() {
        this.dataInfo[0].companyPostalCode = this.originalEdit.companyPostalCode;
    }

    // Modification de la Ville depuis le modal Editer
    editCpnyCity() {
        this.currCpnyCity = this.dataInfo[0].companyCity;
        this.editStatus |= 16384;
    }

    // Valider modifs de la Ville depuis le modal Editer
    validateCpnyCity() {
        this.dataInfo[0].companyCity = this.currCpnyCity;
        this.editStatus &= ~16384;
    }

    // Annuler modifs de la Ville depuis le modal Editer
    cancelCpnyCity() {
        this.editStatus &= ~16384;
    }

    // Défaire modifs de la Ville depuis le modal Editer
    rewindCpnyCity() {
        this.dataInfo[0].companyCity = this.originalEdit.companyCity;
    }

    // Modification du Pays depuis le modal Editer
    editCpnyCountry() {
        this.currCpnyCountry = this.dataInfo[0].companyCountry;
        this.editStatus |= 32768;
    }

    // Valider modifs du Pays depuis le modal Editer
    validateCpnyCountry() {
        this.dataInfo[0].companyCountry = this.currCpnyCountry;
        this.editStatus &= ~32768;
    }

    // Annuler modifs du Pays depuis le modal Editer
    cancelCpnyCountry() {
        this.editStatus &= ~32768;
    }

    // Défaire modifs du Pays depuis le modal Editer
    rewindCpnyCountry() {
        this.dataInfo[0].companyCountry = this.originalEdit.companyCountry;
    }

    // Modification du SIREN depuis le modal Editer
    editCpnySiren() {
        this.currCpnySiren = this.dataInfo[0].companySiren;
        this.editStatus |= 65536;
    }

    // Valider modifs du SIREN depuis le modal Editer
    validateCpnySiren() {
        this.dataInfo[0].companySiren = this.currCpnySiren;
        this.editStatus &= ~65536;
    }

    // Annuler modifs du SIREN depuis le modal Editer
    cancelCpnySiren() {
        this.editStatus &= ~65536;
    }

    // Défaire modifs du SIREN depuis le modal Editer
    rewindCpnySiren() {
        this.dataInfo[0].companySiren = this.originalEdit.companySiren;
    }

    // Modification du N° de TVA depuis le modal Editer
    editCpnyTva() {
        this.currCpnyTva = this.dataInfo[0].companyTva;
        this.editStatus |= 131072;
    }

    // Valider modifs du N° de TVA depuis le modal Editer
    validateCpnyTva() {
        this.dataInfo[0].companyTva = this.currCpnyTva;
        this.editStatus &= ~131072;
    }

    // Annuler modifs du N° de TVA depuis le modal Editer
    cancelCpnyTva() {
        this.editStatus &= ~131072;
    }

    // Défaire modifs du N° de TVA depuis le modal Editer
    rewindCpnyTva() {
        this.dataInfo[0].companyTva = this.originalEdit.companyTva;
    }

    // Ajout d'un produit depuis le modal Editer
    startAddProduct() {
        this.editStatus |= 262144;
    }

    // Valider l'ajout d'un produit depuis le modal Editer
    validateAddProduct(productId: number, qty: number) {
        qty = this.updateProductQuantity(qty, productId);

        const prod = this.availableProducts.find(p => p.productID === productId);
        this.orderLight.push({
            productID: prod.productID,
            labelP: prod.labelP,
            amountP: prod.amountP,
            qty,
            typeP: prod.typeP,
            qteStock: prod.qteStock
        } as OrderLight);

        this.totalAmountOrder = 0;
        this.orderLight.forEach(el => this.totalAmountOrder += (el.amountP * el.qty))

        this.editStatus &= ~262144;
    }

    // Annuler l'ajout d'un produit depuis le modal Editer
    cancelAddProduct() {
        this.editStatus &= ~262144;
    }

    // Renvoie la quantité max d'un produit
    getMaxForProduct(productId: number) {
        if (!productId)
            return null;

        const prod = this.availableProducts.find(p => p.productID === productId);
        return (prod.qteStock > 0) ? prod.qteStock : null;
    }

    // Renvoie la nouvelle quantité d'un produit
    updateProductQuantity(qty: number, productId: number) {
        if (typeof (qty) !== 'number')
            qty = Number(qty);

        const maxQty = this.getMaxForProduct(productId);

        if (maxQty > 0)
            qty = Math.min(qty, maxQty);

        return Math.max(1, qty);
    }

    getAvailableProducts(): OrderLight[] {
        return this.availableProducts.filter(product => this.orderLight.findIndex(order => order.productID == product.productID) < 0);
    }

    removeProduct(productId: number) {
        this.orderLight = this.orderLight.filter(order => order.productID != productId);

        this.totalAmountOrder = 0;
        this.orderLight.forEach(el => this.totalAmountOrder += (el.amountP * el.qty))
    }

    // Modification de la Quantité d'un Produit depuis le modal Editer
    editProductQty(order: OrderLight) {
        (order as any).tmpQty = order.qty;
    }

    // Valider modifs de la Quantité d'un Produit depuis le modal Editer
    validateProductQty(order: OrderLight) {
        order.qty = this.updateProductQuantity((order as any).tmpQty, order.productID);
        (order as any).tmpQty = undefined;

        this.totalAmountOrder = 0;
        this.orderLight.forEach(el => this.totalAmountOrder += (el.amountP * el.qty))
    }

    // Annuler modifs de la Quantité d'un Produit depuis le modal Editer
    cancelProductQty(order: OrderLight) {
        (order as any).tmpQty = undefined;
    }

    // Défaire modifs de la Quantité d'un Produit depuis le modal Editer
    rewindProductQty(order: OrderLight) {
        const ogProduct = this.originalOrder.find(o => o.productID === order.productID);
        if (ogProduct)
            order.qty = ogProduct.qty;
    }

    rewindOrder() {
        this.orderLight = this.originalOrder.map(order => ({ ...order })) as OrderLight[];

        this.totalAmountOrder = 0;
        this.orderLight.forEach(el => this.totalAmountOrder += (el.amountP * el.qty))
    }

    didOrderChange(order: OrderLight) {
        const ogProduct = this.originalOrder.find(o => o.productID === order.productID);
        if (!ogProduct)
            return false;

        return order.qty !== ogProduct.qty;
    }

    didFullOrderChange() {
        if (!this.originalOrder)
            return false;

        if (this.orderLight.length !== this.originalOrder.length)
            return true;

        let foundOrders = [];
        for (let order of this.orderLight) {
            const equivI = this.originalOrder.findIndex(o => o.productID === order.productID);
            if (!foundOrders.includes(equivI))
                foundOrders.push(equivI);

            const equivalentOrder = this.originalOrder[equivI];
            if (!equivalentOrder)
                return true;

            if (equivalentOrder.qty !== order.qty)
                return true;
        }

        if (foundOrders.length !== this.orderLight.length)
            return true;

        return false;
    }

    // Enregistrement des infos supplémentaires dans la modale Editer
    sendNewInfos(close: boolean, companyID: number) {
        this.actualCompanyID = companyID;
        let companyUnisiteCode: string = null;
        let sageCode: string = null;
        let invoiceCode: string = null;
        if (!Utils.IsNullOrWhiteSpace(this.rentingAddInfosForm.value.companyUnisiteCode)) companyUnisiteCode = this.rentingAddInfosForm.value.companyUnisiteCode.trim();
        if (!Utils.IsNullOrWhiteSpace(this.rentingAddInfosForm.value.sageCode)) sageCode = this.rentingAddInfosForm.value.sageCode.trim();
        if (!Utils.IsNullOrWhiteSpace(this.rentingAddInfosForm.value.invoiceCode)) invoiceCode = this.rentingAddInfosForm.value.invoiceCode.trim();

        this.rentingAddInfoSub = this.api.addInfosRenting(
            this.actualRentingID,
            this.actualCompanyID,
            companyUnisiteCode,
            sageCode,
            this.rentingAddInfosForm.value.bank,
            invoiceCode,
            this.rentingAddInfosForm.value.renewal
        ).subscribe(data => {
            let index = this.allRenting.findIndex(i => i.rentingID == this.actualRentingID);
            if (index > -1) {
                this.allRenting[index].companyUnisiteCode = companyUnisiteCode;
                this.allRenting[index].sageCode = sageCode;
                this.allRenting[index].bank = this.rentingAddInfosForm.value.bank;
                this.allRenting[index].invoiceCode = invoiceCode;
            }

            if (close) {
                this.closeModal("confirmationModal");
                this.closeModal("editRentingModal");
                this.refreshTab();
            }
            if (this.rentingAddInfoSub != null) this.rentingAddInfoSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "addInfosRenting, id = " + this.actualRentingID, new Date().toString());
            if (this.rentingAddInfoSub != null) this.rentingAddInfoSub.unsubscribe();
        });
        this.errorForm = false;

        // Si nouvelles données à modifier
        if (this.additionalConfirmText.length > 0) {
            this.updateRentingInfoSub = this.api.updateRentingInfo(
                {
                    rentingID: this.dataInfo[0].rentingID,
                    ctcID: (this.dataInfo[0].ctcID !== this.originalEdit.ctcID) ? this.dataInfo[0].ctcID : null,
                    status: (this.dataInfo[0].status !== this.originalEdit.status) ? this.dataInfo[0].status : null,
                    ixellAccount: (this.dataInfo[0].ixellAccount !== this.originalEdit.ixellAccount) ? this.dataInfo[0].ixellAccount : null,
                    customerStatus: (this.dataInfo[0].customerStatus !== this.originalEdit.customerStatus) ? this.dataInfo[0].customerStatus : null,
                    technology: (this.dataInfo[0].technology !== this.originalEdit.technology) ? this.dataInfo[0].technology : null,
                    companyType: (this.dataInfo[0].companyType !== this.originalEdit.companyType) ? this.dataInfo[0].companyType : null,
                    companyTypeName: (this.dataInfo[0].companyTypeName !== this.originalEdit.companyTypeName) ? this.dataInfo[0].companyTypeName : null,
                    leader: (this.dataInfo[0].leader !== this.originalEdit.leader) ? this.dataInfo[0].leader : null,
                    bodyshopInterlocutor: (this.dataInfo[0].bodyshopInterlocutor !== this.originalEdit.bodyshopInterlocutor) ? this.dataInfo[0].bodyshopInterlocutor : null,
                    companyPhone: (this.dataInfo[0].companyPhone !== this.originalEdit.companyPhone) ? this.dataInfo[0].companyPhone : null,
                    companyMail: (this.dataInfo[0].companyMail !== this.originalEdit.companyMail) ? this.dataInfo[0].companyMail : null,
                    companyDirectLign: (this.dataInfo[0].companyDirectLign !== this.originalEdit.companyDirectLign) ? this.dataInfo[0].companyDirectLign : null,
                    companySocialReason: (this.dataInfo[0].companySocialReason !== this.originalEdit.companySocialReason) ? this.dataInfo[0].companySocialReason : null,
                    companyAddress: (this.dataInfo[0].companyAddress !== this.originalEdit.companyAddress) ? this.dataInfo[0].companyAddress : null,
                    companyPostalCode: (this.dataInfo[0].companyPostalCode !== this.originalEdit.companyPostalCode) ? this.dataInfo[0].companyPostalCode : null,
                    companyCity: (this.dataInfo[0].companyCity !== this.originalEdit.companyCity) ? this.dataInfo[0].companyCity : null,
                    companyCountry: (this.dataInfo[0].companyCountry !== this.originalEdit.companyCountry) ? this.dataInfo[0].companyCountry : null,
                    companySiren: (this.dataInfo[0].companySiren !== this.originalEdit.companySiren) ? this.dataInfo[0].companySiren : null,
                    companyTva: (this.dataInfo[0].companyTva !== this.originalEdit.companyTva) ? this.dataInfo[0].companyTva : null,
                    orders: this.didFullOrderChange() ? this.orderLight : null
                } as IRentingPatch
            ).subscribe(() => {
                if (this.updateRentingInfoSub != null) this.updateRentingInfoSub.unsubscribe();
            }, error => {
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "updateRentingInfo, id = " + this.dataInfo[0].rentingID, new Date().toString());
                if (this.updateRentingInfoSub != null) this.updateRentingInfoSub.unsubscribe();
            })
        }
    }

    // Enregistrement du nouveau statut de la demande de location
    sendNewStatus() {
        this.api.updateStatusRenting(this.actualRentingID, this.actualStatus).subscribe(data => {
            if (data == true) {
                let index = this.allRenting.findIndex(i => i.rentingID == this.actualRentingID);
                if (index > -1) {
                    this.allRenting[index].status = this.actualStatus;
                }
                switch (this.actualStatus) {
                    case 1:
                        this.toggleTab('1', 'nav-stat1', 'nav-stat1-tab');
                        this.confirmationStatus = "Accepter";
                        break;
                    case 2:
                        this.toggleTab('2', 'nav-stat2', 'nav-stat2-tab');
                        this.confirmationStatus = "Refuser";
                        break;
                    case 3:
                        this.toggleTab('2', 'nav-stat2', 'nav-stat2-tab');
                        this.confirmationStatus = "Abandonner";
                        break;
                }
            }
            if (this.statusRentingSub != null) this.statusRentingSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "updateStatusRenting, id = " + this.actualRentingID + ", status = " + this.actualStatus, new Date().toString());
            if (this.statusRentingSub != null) this.statusRentingSub.unsubscribe();
        });
        this.closeModal("confirmationModal");
        this.closeModal("editRentingModal");
    }

    computeAdditionalEditInfo() {
        this.additionalConfirmText = '';

        if (this.dataInfo[0].status !== this.originalEdit.status) {
            const statusTranslate = ['En attente', 'Accepté', 'Refusé', 'Abandonné'];
            this.additionalConfirmText += `\r\n\t• Statut de la demande changé de "${statusTranslate[this.originalEdit.status]}" vers "${statusTranslate[this.dataInfo[0].status]}"`;
        }

        if (this.dataInfo[0].ixellAccount !== this.originalEdit.ixellAccount)
            this.additionalConfirmText += `\r\n\t• N° compte Ixell changé de "${this.originalEdit.ixellAccount}" vers "${this.dataInfo[0].ixellAccount}"`;

        if (this.dataInfo[0].customerStatus !== this.originalEdit.customerStatus)
            this.additionalConfirmText += `\r\n\t• Tarif changé de "${this.originalEdit.customerStatus}" vers "${this.dataInfo[0].customerStatus}"`;

        if (this.dataInfo[0].technology !== this.originalEdit.technology)
            this.additionalConfirmText += `\r\n\t• Technologie changée de "${this.originalEdit.technology}" vers "${this.dataInfo[0].technology}"`;

        if (this.dataInfo[0].companyType !== this.originalEdit.companyType)
            this.additionalConfirmText += `\r\n\t• Appartenance client changée de "${this.originalEdit.companyType}" vers "${this.dataInfo[0].companyType}"`;

        if (this.dataInfo[0].companyTypeName !== this.originalEdit.companyTypeName)
            this.additionalConfirmText += `\r\n\t• Nom ${this.dataInfo[0].companyType} client changé de "${this.originalEdit.companyTypeName}" vers "${this.dataInfo[0].companyTypeName}"`;

        if (this.dataInfo[0].ctcID !== this.originalEdit.ctcID)
            this.additionalConfirmText += `\r\n\t• CT changé de "${this.originalEdit.ctcFirstname} ${this.originalEdit.ctcName}" vers "${this.dataInfo[0].ctcFirstname} ${this.dataInfo[0].ctcName}"`;

        if (this.dataInfo[0].companySocialReason !== this.originalEdit.companySocialReason)
            this.additionalConfirmText += `\r\n\t• Raison sociale de la société changée de "${this.originalEdit.companySocialReason}" vers "${this.dataInfo[0].companySocialReason}"`;

        if (this.dataInfo[0].companyAddress !== this.originalEdit.companyAddress)
            this.additionalConfirmText += `\r\n\t• Adresse de la société changée de "${this.originalEdit.companyAddress}" vers "${this.dataInfo[0].companyAddress}"`;

        if (this.dataInfo[0].companyPostalCode !== this.originalEdit.companyPostalCode)
            this.additionalConfirmText += `\r\n\t• Code postal de la société changé de "${this.originalEdit.companyPostalCode}" vers "${this.dataInfo[0].companyPostalCode}"`;

        if (this.dataInfo[0].companyCity !== this.originalEdit.companyCity)
            this.additionalConfirmText += `\r\n\t• Ville de la société changée de "${this.originalEdit.companyCity}" vers "${this.dataInfo[0].companyCity}"`;

        if (this.dataInfo[0].companyCountry !== this.originalEdit.companyCountry)
            this.additionalConfirmText += `\r\n\t• Pays de la société changé de "${this.originalEdit.companyCountry}" vers "${this.dataInfo[0].companyCountry}"`;

        if (this.dataInfo[0].companySiren !== this.originalEdit.companySiren)
            this.additionalConfirmText += `\r\n\t• SIREN de la société changé de "${this.originalEdit.companySiren}" vers "${this.dataInfo[0].companySiren}"`;

        if (this.dataInfo[0].companyTva !== this.originalEdit.companyTva)
            this.additionalConfirmText += `\r\n\t• N° de TVA Intracommunautaire de la société changé de "${this.originalEdit.companyTva}" vers "${this.dataInfo[0].companyTva}"`;

        if (this.dataInfo[0].leader !== this.originalEdit.leader)
            this.additionalConfirmText += `\r\n\t• Nom du dirigeant de la société changé de "${this.originalEdit.leader}" vers "${this.dataInfo[0].leader}"`;

        if (this.dataInfo[0].bodyshopInterlocutor !== this.originalEdit.bodyshopInterlocutor)
            this.additionalConfirmText += `\r\n\t• Nom de l'interlocuteur carrosserie changé de "${this.originalEdit.bodyshopInterlocutor}" vers "${this.dataInfo[0].bodyshopInterlocutor}"`;

        if (this.dataInfo[0].companyPhone !== this.originalEdit.companyPhone)
            this.additionalConfirmText += `\r\n\t• N° de tél de la société changé de "${this.originalEdit.companyPhone}" vers "${this.dataInfo[0].companyPhone}"`;

        if (this.dataInfo[0].companyMail !== this.originalEdit.companyMail)
            this.additionalConfirmText += `\r\n\t• E-Mail de la société changé de "${this.originalEdit.companyMail}" vers "${this.dataInfo[0].companyMail}"`;

        if (this.dataInfo[0].companyDirectLign !== this.originalEdit.companyDirectLign)
            this.additionalConfirmText += `\r\n\t• Ligne directe de la société changée de "${this.originalEdit.companyDirectLign}" vers "${this.dataInfo[0].companyDirectLign}"`;

        const newProducts = this.orderLight.filter(o => this.originalOrder.findIndex(oo => oo.productID === o.productID) < 0);
        const delProducts = this.originalOrder.filter(oo => this.orderLight.findIndex(o => o.productID === oo.productID) < 0);
        const chnProducts = this.orderLight.map(o => {
            const f = this.originalOrder.find(oo => oo.productID === o.productID);
            return ((f) && (f.qty !== o.qty)) ? { og: f, nw: o } : null;
        }).filter(chn => chn !== null);

        for (let newProduct of newProducts)
            this.additionalConfirmText += `\r\n\t• Ajout du produit "${newProduct.labelP}" × ${newProduct.qty} à la commande`;

        for (let delProduct of delProducts)
            this.additionalConfirmText += `\r\n\t• Suppression du produit "${delProduct.labelP}" de la commande`;

        for (let chnProduct of chnProducts)
            this.additionalConfirmText += `\r\n\t• Modification dans la commande de la quantité du produit "${chnProduct.nw.labelP}" de ${chnProduct.og.qty} vers ${chnProduct.nw.qty}`;

        if (this.additionalConfirmText.length > 0)
            this.additionalConfirmText = "Récapitulatif des modifications :" + this.additionalConfirmText
    }

    confirmToSendNewInfoAndStatus(id, info: any) {
        this.computeAdditionalEditInfo();
        this.confirmationModal(id, () => { this.sendNewInfos(false, info.companyID); this.sendNewStatus(); })
    }

    confirmToSendNewInfo(id, info: any) {
        this.computeAdditionalEditInfo();

        const sendInfoCb = () => { this.sendNewInfos(true, info.companyID); };

        if (this.additionalConfirmText.length > 0)
            this.confirmationModal(id, sendInfoCb);
        else
            sendInfoCb();
    }

    // ///// VOIR V2 POUR MAIL AUTOMATIQUES
    // Envoi du mail au CTC
    // mail(rentingID: number, ctcMail: string, ctcLanguage: string) {
    //   this.api.sendValidationRentingMail(ctcMail, ctcLanguage).subscribe(data => {
    //     let index = this.allRenting.findIndex(i => i.rentingID == rentingID);
    //     if (index > -1) {
    //       if (data == true) {
    //         this.openSnackBar("Mail bien envoyé!", "Fermer");
    //         this.api.updateStatusRenting(rentingID, 2).subscribe(data2 => {
    //           if (data2 == true) {
    //             this.allRenting[index].status = 2;
    //             this.refreshRentingList(this.actualStatus);
    //           }
    //         }, error => {
    //           console.log(error);
    //         })
    //       }
    //     }
    //   }
    //   , error => {
    //     this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "sendValidationRentingMail , id = " + rentingID + ", mail = " + ctcMail + ", language = " + ctcLanguage, new Date().toString());
    //     console.log(error);
    //     this.openSnackBar("Erreur lors de l'envoi du mail", "Fermer");
    //   }); 
    // }

    // VOIR V2 POUR MAIL AUTOMATIQUES
    // sendMail(rentingID: number, ctcMail: string, ctcLanguage: string, modal: string) {
    //   if (modal == "editRentingModal") {
    //     if (this.rentingAddInfosForm.status == "VALID") {
    //       this.mail(rentingID, ctcMail, ctcLanguage);
    //     }
    //     else {
    //       this.errorForm = true;
    //       this.rentingAddInfosForm.markAllAsTouched();
    //     }
    //   }
    //   else if (modal == "mailModal") {
    //     this.mail(rentingID, ctcMail, ctcLanguage);
    //     this.closeModal('mailModal');
    //   }
    // }

    downloadFile(data: Blob, id: number) {
        const element = document.createElement('a');
        element.href = URL.createObjectURL(data);
        element.download = "Formulaire de commande ixellcolorconnect-N°" + id.toString();
        document.body.appendChild(element);
        element.click();
    }

    downloadExcel(id: number) {
        this.api.downloadExcel(id).subscribe(res => {
            this.downloadFile(res.data, id);
        }, error => {
            console.log(error);
        })
    }

    sortScale(sort: Sort, status: string) {
        var data = this.rentingLst;
        Constants.sortScale(sort, status, data);
        this.rentingLst = data.slice();
        this.rentingSource = new MatTableDataSource(this.rentingLst);
    }

    ngOnDestroy() {
        if (this.rentingSub != null) this.rentingSub.unsubscribe();
        if (this.rentingInfoSub != null) this.rentingInfoSub.unsubscribe();
        if (this.rentingAddInfoSub != null) this.rentingAddInfoSub.unsubscribe();
        if (this.checkedRentingSub != null) this.checkedRentingSub.unsubscribe();
        if (this.orderLightSub != null) this.orderLightSub.unsubscribe();
        if (this.statusRentingSub != null) this.statusRentingSub.unsubscribe();
        if (this.selectCTForRentingSub != null) this.selectCTForRentingSub.unsubscribe();
        if (this.updateRentingInfoSub != null) this.updateRentingInfoSub.unsubscribe();
        if (this.selectRentableProductsLightSub != null) this.selectRentableProductsLightSub.unsubscribe();
    }

}
